<template>
  <div class="app-container">
    <a-skeleton :loading="loading">
      <a-result v-if="error === true" title="授权提醒" sub-title="首次使用时需要使用飞书授权哦，请授权后再试吧~">
        <template #icon>
          <a-icon type="safety-certificate" theme="twoTone" />
        </template>
        <template #extra>
          <a-button type="primary" @click="onReLogin"> 立即授权 </a-button>
        </template>
      </a-result>
    </a-skeleton>
    <div :id="`feishu-doc-${token}`" />
  </div>
</template>
<script>
import { setCookies } from '@/utils/utils';
import { getSignature } from '@/api/system/auth';
import { setDocumentPermission } from '@/api/business/document';

export default {
  name: 'FeiShuDocumentNew',
  props: {
    token: {
      type: String,
      default: null
    },
    options: {
      type: Object,
      default: () => {
        return {
          height: '60vh', // 高度
          titleVisible: true, // 是否展示标题
          everyoneEdit: false // 是否所有人可编辑
        };
      }
    }
  },
  data() {
    return {
      loading: true,
      error: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.authPage();
    });
  },
  methods: {
    authPage() {
      getSignature({ url: `https://xjs3ti3gwc.feishu.cn/docx/${this.token}` })
        .then(response => {
          this.error = false;
          this.loading = false;
          const openId = response.data.openId;
          const signature = response.data.signature;
          const appId = response.data.appId;
          const timestamp = response.data.timestamp;
          const nonceStr = response.data.nonceStr;
          const url = response.data.url;
          const jsApiList = ['DocsComponent'];
          const that = this;
          console.log(openId, signature, appId, timestamp, nonceStr, url, jsApiList);

          const myComponent = new window.DocComponentSdk({
            src: url,
            mount: document.querySelector(`#feishu-doc-${this.token}`), // 将组件挂在到哪个元素上
            auth: {
              openId, // 当前登录用户的open id，要确保与生成 signature 使用的 user_access_token 相对应，使用 app_access_token 时此项不填。
              signature, // 签名
              appId, // 应用 appId
              timestamp, // 时间戳（毫秒）
              nonceStr, // 随机字符串
              url, // 参与签名加密计算的url
              jsApiList // 指定要使用的组件，请根据对应组件的开发文档填写。如云文档组件，填写['DocsComponent']
            },
            size: {
              minHeight: 400,
              height: this.options.height // 该参数控制了页面的最大展开高度,不允许为Auto,也不能不写,会导致锚点定位,文本搜索失效
            },
            config: {
              extensions: {
                suiteNavBar: {
                  disable: false,
                  docComponentHeader: {
                    height: 56,
                    shareBtn: {
                      enable: false
                    },
                    collabAvatar: {
                      enable: false // 是否显示协作者头像
                    },
                    bottomLine: {
                      enable: false // header底下的线是否存在
                    },
                    moreMenu: {
                      docMiniApp: {
                        enable: false
                      }
                    }
                  }
                },
                like: {
                  disable: false // 显示点赞
                },
                fullscreen: {
                  enable: true // 显示全屏按钮
                },
                content: {
                  titleVisible: that.options.titleVisible,
                  padding: [16, 0, 16, 0]
                }
              }
            },
            onAuthError: err => {
              console.log('onAuthError', err);
            },
            onError: err => {
              console.log('onError', err);
            }
          });

          myComponent.start().then(() => {
            myComponent.register('SUITE_TITLE_CHANGE', function ({ title }) {
              if (title) {
                that.$emit('onTitleChange', title);
              }
            });
            myComponent.register('AUTH_CHANGE', function (auth) {
              // 如果当前用户没有编辑权限，且文档所有人可编辑，则给该用户赋予编辑权限
              if (auth.editable === false && that.options.everyoneEdit === true) {
                setDocumentPermission({ token: that.token }).then(() => {
                  console.log('添加编辑权限成功');
                });
              } else {
                console.log('已有编辑权限');
              }
            });
          });
          // 销毁组件
          // myComponent.destroy();
          // console.log('myComponent', myComponent);
          // 通过setFeatureConfig方法修改组件的配置属性
        })
        .catch(err => {
          console.log('catch', err);
          this.error = true;
          this.loading = false;
        });
    },
    onReLogin() {
      localStorage.removeItem('token');
      localStorage.removeItem('user_info');
      localStorage.removeItem('refreshToken');
      setCookies('token'); // 清除token
      setCookies('refreshToken'); // 清除refreshToken
      window.location.href = process.env.VUE_APP_SSO_URL + '?url=' + window.location.href;
    }
  }
};
</script>
